<app-clinical-assessment
  [crossReference]="crossReference"
  [user]="clinicalAssessmentGridData?.user"
  [permissions]="clinicalAssessmentGridData?.permissions"
  [crossReferenceOpinionOptions]="clinicalAssessmentGridData?.crossReferenceOpinionOptions"
  [isShowingSearchResults]="clinicalAssessmentGridData?.isShowingSearchResults"
  (updateOpinion)="onUpdateOpinion($event)"
  (addCross)="onAddCross($event)"
  (addNote)="onAddNote($event)"
/>
